(() => {
    var App = (() => {
        var initialize = () => {
            CartOrderDateApp.init();
			VideoMuteControlWrapperApp.init();
			ConnectedProductPickerApp.init();
			DemensionSizeDataApp.init();
        }
        return {
            init: initialize
        }
    })();
    
    document.addEventListener('DOMContentLoaded', () => {
        App.init();
    });

    var CartOrderDateApp = (() => {
        var initialize = () => {
            document.querySelectorAll('[js-order-note-date]').forEach(element => {
                element.addEventListener('change', () => {
                    console.log('here is date element value', element, element.value);
                    fetch('/cart/update.js', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({
                            note: `Date: ${element.value}`
                        })
                    })
                    .then(response => response.json())
                    .then(data => {
                        console.log('Cart note updated successfully:', data);
                        // Optional: Show success message to user
                    })
                    .catch(error => {
                        console.error('Error updating cart note:', error);
                        // Optional: Show error message to user
                    });
                });
            });
        }
        return {
            init: initialize
        }
    })();

	var DemensionSizeDataApp = (() => {
		var initialize = () => {
			document.querySelectorAll('xo-carousel').forEach(element => {
				element.addEventListener('slide:change', e => {
					document.querySelectorAll('.product-measurement-info-wrapper').forEach(sizeItem => {
						if (sizeItem.getAttribute('data-demension-index') && sizeItem.getAttribute('data-demension-index') === String(e.detail.index + 1)) {
							sizeItem.classList.add('active');
						} else {
							sizeItem.classList.remove('active');
						}
					})
					const imagez_slide_index = document.querySelectorAll('xo-carousel-slide')[e.detail.index].getAttribute("aria-label");
					const slider_counter = document.querySelector('[data-slider-counter-index]');

					if (imagez_slide_index && slider_counter) {
						slider_counter.innerHTML = imagez_slide_index
					}
				});
			});
		}
		return {
            init: initialize
        }
	})();

	var VideoMuteControlWrapperApp = (() => {
		var muteVideos = (container, mute=true) => {
			if (!container) return;
			console.log('here is mutevideos function', container, mute);
			container.querySelectorAll('video').forEach(element => {
				element.muted = mute;
				if (mute) element.volume = 0;
			});
		}
		var initialize = () => {
			document.querySelectorAll('[js-video-mute-control-wrapper]').forEach(element => {
				muteVideos(element, element.getAttribute('data-mute')==='true');
			});
		}
		return {
			init: initialize
		}
	})();

	var ConnectedProductPickerApp = (() => {
		var show = (container, parent_index) => {
			if (!container) return;
			const index_array = String(parent_index).split('-').reduce((acc, num, index, arr) => {
				acc.push(arr.slice(0, index + 1).join('-'));
				return acc;
			}, []);
			let i = 0;
			let temp_index;
			container.querySelectorAll('[data-parent-index]').forEach(element => {
				let subindex = null;
				if (i < index_array.length) {
					temp_index = index_array[i];
					try {
						subindex = String(parent_index).replace(temp_index, '').split('-')[1];
					} catch (error) {}
				} else {
					temp_index = `${temp_index}-1`;
				}
				if (!subindex) subindex = '1';
				console.log('here is temp', parent_index, temp_index, subindex);
				if (element.getAttribute('data-parent-index') === temp_index) {
					element.classList.add('active');
					const flickity = element.querySelector('.option-value-list-wrapper.flickity-enabled');
					if (flickity) {
						const f = new Flickity(flickity);
						console.log('f', f);
						f.resize();
					}
					element.querySelectorAll('[data-index]').forEach(subelement => {
						if (subelement.getAttribute('data-index') === String(subindex)) {
							subelement.classList.add('active');
						} else {
							subelement.classList.remove('active');
						}
					});
					i++;
				} else {
					element.classList.remove('active');
				}
			});
		}
		var initEachContainer = (container) => {
			if (!container) return;
			container.querySelectorAll('[data-parent-index] [js-option-picker][data-index]').forEach(element => {
				element.addEventListener('click', () => {
					show(container, `${element.closest('[data-parent-index]').getAttribute('data-parent-index')}-${element.getAttribute('data-index')}`);
				});
			});
			const activeProduct = container.querySelector('[data-parent-index] .connected-product.active');
			if (activeProduct) {
				show(container, activeProduct.closest('[data-parent-index]').getAttribute('data-parent-index'));
			}
		}
		var initialize = () => {
			document.querySelectorAll('[js-product-connected-products-container]').forEach(container => {
				initEachContainer(container);
			});
		}
		return {
			init: initialize
		}
	})();
})();